import { Injectable } from '@angular/core';
export enum LogLevel {
  Log,
  Error,
  Warn,
  Info,
  Debug,
}

export enum LogColor {
  Log = 'color: white; font-weight: bold;',
  Error = 'color: Red; font-weight: bold;',
  Warn = 'color: Orange; font-weight: bold;',
  Info = 'color: blue; font-weight: bold;',
  Debug = 'color: green; font-weight: bold;',
}

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private records = [];
  private debugLevel: number = 1;

  private between(val: number, min: number, max: number) {
    return val >= min && val <= max;
  }
  public log(msg: any, logLevel?: number): void {
    const level = logLevel ? LogLevel[logLevel] : LogLevel[0];
    if (this.between(this.debugLevel, 1, 100)) {
      console[level.toLowerCase()]('%c[' + level + '] ', LogColor[level], msg);
    } else if (this.between(this.debugLevel, 101, 500)) {
      console[level.toLowerCase()]('%c[' + level + '] ', LogColor[level], msg);
    } else if (this.between(this.debugLevel, 501, 1000)) {
      console[level.toLowerCase()]('%c[' + level + '] ', LogColor[level], msg);
    }
    this.records.push(msg);
  }
}
